import React, { useState } from 'react';

function AppImage({ src, smallSrc, alt = "Image Name", className = "", ...props }) {
  const [error, setError] = useState(false);

  const handleError = (e) => {
    setError(true);
    e.target.src = "/assets/images/no_image.png"; // fallback image
  };

  // Always show fallback image if there is an error
  if (error) {
    return <img src="/assets/images/no_image.png" alt={alt} className={className} {...props} />;
  }

  return (
    <picture>
      {smallSrc && <source srcSet={smallSrc} media="(max-width: 767px)" />}
      <img
        src={src}
        alt={alt}
        className={className}
        onError={handleError}
        {...props}
      />
    </picture>
  );
}

export default AppImage;
